module.exports = __webpack_public_path__ + "img/car2_2.375e48b2.png";